
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"100","viewBox":"0 0 110 110"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 82.007v8.64c0 7.142 17.4 12.95 38.849 12.95S77.7 97.789 77.7 90.647v-8.64c-8.357 5.888-23.633 8.64-38.849 8.64S8.357 87.9 0 82.007zM64.748 25.9c21.452 0 38.852-5.808 38.852-12.95S86.2 0 64.748 0 25.9 5.807 25.9 12.95 43.3 25.9 64.748 25.9zM0 60.782v10.441c0 7.143 17.4 12.95 38.849 12.95S77.7 78.365 77.7 71.223V60.782c-8.357 6.879-23.653 10.441-38.849 10.441S8.357 67.662 0 60.782zm84.172 2.226C95.766 60.762 103.6 56.594 103.6 51.8v-8.64c-4.7 3.317-11.6 5.583-19.428 6.979zM38.849 32.374C17.4 32.374 0 39.618 0 48.561s17.4 16.187 38.849 16.187S77.7 57.5 77.7 48.561 60.3 32.374 38.849 32.374zm44.372 11.391c12.14-2.185 20.379-6.474 20.379-11.391v-8.64c-7.183 5.079-19.526 7.81-32.516 8.458 5.966 2.893 10.357 6.778 12.137 11.573z","fill":"#63cdf5"}})])
          )
        }
      }
    